import "./style.css";

import email from "./../../img/icons/email2.png";
import linkedIn from "./../../img/icons/linkedIn.svg";
import gitHub from "./../../img/icons/gitHub.svg";

const Footer = () => {
  return (
    <footer className="footer">
      <div className="container">
        <div className="footer__wrapper">
          <ul className="social">
            <li className="social__item">
              <a
                href="https://github.com/LeonidShamarin"
                target="_blank"
                rel="noopener noreferrer"
              >
                <img src={gitHub} alt="GitHub" />
              </a>
            </li>
            <li className="social__item">
              <a
                href="https://www.linkedin.com/in/leonid-shamarin/"
                target="_blank"
                rel="noopener noreferrer"
              >
                <img src={linkedIn} alt="LinkedIn" />
              </a>
            </li>
            <li className="social__item-email">
              <a href="mailto:leonideko1@gmail.com">
                <img src={email} alt="Email" />
              </a>
            </li>
          </ul>
          <div className="copyright">
            <p>© 2026 Shamarin Leonid</p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
